import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import {pinia} from './store'
import 'vant/lib/index.css';
import vant from 'vant'
import VueQrcode from '@chenfengyuan/vue-qrcode';
import { TimePicker } from 'vant';
// import VConsole from 'vconsole';
// const vConsole = new VConsole();




const app = createApp(App)
app.use(pinia)
app.use(router)
app.use(vant)
app.use(VueQrcode)
app.use(TimePicker)
app.mount('#main-app')
